export default {
  ACTIVE: 'ACTIVE',
  INVALID: 'INVALID',
  EXPIRED: 'EXPIRED',
  EXPIRED_ON_BOOKING_CREATION: 'EXPIRED_ON_BOOKING_CREATION',
  SUSPENDED: 'SUSPENDED',
  WRONG_PHONE_NUMBER: 'WRONG_PHONE_NUMBER',
  NO_STOPS_IN_COMMUNE_BORDER: 'NO_STOPS_IN_COMMUNE_BORDER',
};
